export enum EventStatus {
  ACTIVE = 'active',
  ACKNOWLEDGED = 'acknowledged',
  SNOOZED = 'snoozed',
  CLOSED = 'closed'
}
